// extracted by mini-css-extract-plugin
module.exports = {"btn-submit":"formUserProfile_btn-submit__39CEf"};